/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { ButtonText } from '@powdr/constants';

export const BulkTicketsForm = ({
  captchaSiteKeyBasin,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText = null,
}) => {
  const captchaRef = useRef();

  return (
    <form
      id="bulk-tickets-form"
      onSubmit={(e) => processForm(e, '4cf249761f90', null, captchaRef)}
    >
      <h3>Group Name *</h3>
      <input
        className="form-control"
        id="firstName"
        name="groupName"
        type="text"
        required
      />

      <h3>Number of People in Group *</h3>
      <input
        className="form-control"
        id="peopleInGroup"
        name="peopleInGroup"
        type="number"
        required
      />

      <h3>First Name *</h3>
      <input
        className="form-control"
        id="firstName"
        name="firstName"
        type="text"
        required
      />

      <h3>Last Name *</h3>
      <input
        className="form-control"
        id="lastName"
        name="lastName"
        type="text"
        required
      />

      <h3>Address *</h3>
      <input
        className="form-control"
        id="lastName"
        name="address"
        type="text"
        required
      />

      <h3>State *</h3>
      <select className="form-control" id="state" name="state" required>
        <option selected="selected">
          - select a state -
        </option>
        <option value="AL">Alabama</option>
        <option value="AK">Alaska</option>
        <option value="AB">Alberta</option>
        <option value="AZ">Arizona</option>
        <option value="AR">Arkansas</option>
        <option value="BC">British Columbia</option>
        <option value="CA">California</option>
        <option value="CO">Colorado</option>
        <option value="CT">Connecticut</option>
        <option value="DE">Delaware</option>
        <option value="DC">District of Columbia</option>
        <option value="FL">Florida</option>
        <option value="GA">Georgia</option>
        <option value="HI">Hawaii</option>
        <option value="ID">Idaho</option>
        <option value="IL">Illinois</option>
        <option value="IN">Indiana</option>
        <option value="IA">Iowa</option>
        <option value="KS">Kansas</option>
        <option value="KY">Kentucky</option>
        <option value="LA">Louisiana</option>
        <option value="ME">Maine</option>
        <option value="MB">Manitoba</option>
        <option value="MD">Maryland</option>
        <option value="MA">Massachusetts</option>
        <option value="MI">Michigan</option>
        <option value="MN">Minnesota</option>
        <option value="MS">Mississippi</option>
        <option value="MO">Missouri</option>
        <option value="MT">Montana</option>
        <option value="NE">Nebraska</option>
        <option value="NV">Nevada</option>
        <option value="NB">New Brunswick</option>
        <option value="NH">New Hampshire</option>
        <option value="NJ">New Jersey</option>
        <option value="NM">New Mexico</option>
        <option value="NY">New York</option>
        <option value="NL">Newfoundland and Labrador</option>
        <option value="NC">North Carolina</option>
        <option value="ND">North Dakota</option>
        <option value="NT">Northwest Territories</option>
        <option value="NS">Nova Scotia</option>
        <option value="NU">Nunavut</option>
        <option value="OH">Ohio</option>
        <option value="OK">Oklahoma</option>
        <option value="ON">Ontario</option>
        <option value="OR">Oregon</option>
        <option value="PA">Pennsylvania</option>
        <option value="PE">Prince Edward Island</option>
        <option value="QC">Quebec</option>
        <option value="RI">Rhode Island</option>
        <option value="SK">Saskatchewan</option>
        <option value="SC">South Carolina</option>
        <option value="SD">South Dakota</option>
        <option value="TN">Tennessee</option>
        <option value="TX">Texas</option>
        <option value="UT">Utah</option>
        <option value="VT">Vermont</option>
        <option value="VA">Virginia</option>
        <option value="WA">Washington</option>
        <option value="WV">West Virginia</option>
        <option value="WI">Wisconsin</option>
        <option value="WY">Wyoming</option>
        <option value="YT">Yukon</option>
      </select>

      <h3>Zip / Postal Code *</h3>
      <input
        className="form-control"
        id="zipcode"
        name="zipCode"
        type="text"
        required
      />

      <h3>Phone *</h3>
      <input
        className="form-control"
        id="phoneNumber"
        name="phoneNumber"
        type="tel"
        required
      />

      <h3>Email address *</h3>
      <input
        className="form-control"
        id="email"
        name="email"
        type="email"
        required
      />

      <h3>Season *</h3>
      <ul className="l-group">
        <li className="l-item">
          <input
            className="radio"
            id="season-winter"
            value="Winter"
            type="radio"
            name="research"
            required
          />
          <label htmlFor="season-winter">Winter</label>
        </li>

        <li className="l-item">
          <input
            className="radio"
            id="season-summer"
            value="Summer"
            type="radio"
            name="research"
          />
          <label htmlFor="season-summer">Summer</label>
        </li>
      </ul>

      <h3>Tentative Date(s)</h3>
      <p>Start Date *</p>
      <input
        className="form-control"
        id="startDate"
        name="startDate"
        type="date"
        required
      />

      <p>End Date *</p>
      <input
        className="form-control"
        id="endDate"
        name="endDate"
        type="date"
        required
      />

      <h3>What products or services are you interested in? *</h3>
      <ul className="l-group">
        <li className="l-item">
          <input
            className="checkbox"
            id="winter-lift-tickets"
            name="product-service-interest"
            type="checkbox"
            value="Winter Lift Tickets"
          />
          <label htmlFor="winter-lift-tickets">Winter Lift Tickets</label>
        </li>

        <li className="l-item">
          <input
            className="checkbox"
            id="ski-snowboard-rentals"
            name="product-service-interest"
            type="checkbox"
            value="Ski/Snowboard Rentals"
          />
          <label htmlFor="ski-snowboard-rentals">Ski/Snowboard Rentals</label>
        </li>

        <li className="l-item">
          <input
            className="checkbox"
            id="ski-snowboard-lessons"
            name="product-service-interest"
            type="checkbox"
            value="Ski/Snowboard Lessons"
          />
          <label htmlFor="ski-snowboard-lessons">Ski/Snowboard Lessons</label>
        </li>

        <li className="l-item">
          <input
            className="checkbox"
            id="lodging"
            name="product-service-interest"
            type="checkbox"
            value="Lodging"
          />
          <label htmlFor="lodging">Lodging</label>
        </li>

        <li className="l-item">
          <input
            className="checkbox"
            id="private-dining"
            name="product-service-interest"
            type="checkbox"
            value="Private Dining"
          />
          <label htmlFor="private-dining">Private Dining</label>
        </li>

        <li className="l-item">
          <input
            className="checkbox"
            id="summer-activities"
            name="product-service-interest"
            type="checkbox"
            value="Summer Activities"
          />
          <label htmlFor="summer-activities">Summer Activities</label>
        </li>

        <li className="l-item">
          <input
            className="checkbox"
            id="tubing-hill"
            name="product-service-interest"
            type="checkbox"
            value="Tubing Hill (Winter)"
          />
          <label htmlFor="tubing-hill">Tubing Hill (Winter)</label>
        </li>
      </ul>

      <h3>What else would you like to tell us about your group?</h3>
      <textarea name="additional-info" id="additional-info" rows="9" cols="33" />

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={captchaSiteKeyBasin}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={() => handleCaptchaExpiry()}
      />

      <button type="submit" value="Submit" disabled={!isUserVerified}>
        {buttonText || ButtonText.SUBMIT}
      </button>
    </form>
  );
};

BulkTicketsForm.propTypes = {
  captchaSiteKeyBasin: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};
